import { TABLET_BREAKPOINT } from "@/lib/breakpoints"
import * as React from "react"

function subscribe(onStoreChange: () => void) {
  const mql = window.matchMedia(`(max-width: ${TABLET_BREAKPOINT - 1}px)`)
  mql.addEventListener("change", onStoreChange)
  return () => mql.removeEventListener("change", onStoreChange)
}

function getSnapshot() {
  return window.innerWidth < TABLET_BREAKPOINT
}

function getServerSnapshot() {
  return false
}

export function useIsMobile() {
  return React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
